<template>
  <v-container class="my-16" fluid style="max-width: 960px">
    <v-row class="mt-9">
      <v-col>
        <v-card :disabled="callCenterStore.isDisabledOrder" rounded="xl">
          <v-card-title class="px-9" v-if="isEdit">
            <v-tooltip right color="primary">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :to="{ name: 'dashboard-call-center' }"
                  large
                  color="primary"
                  fab
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon size="32" color="white">{{ icons.mdiArrowLeft }}</v-icon>
                </v-btn>
              </template>
              <span>Geri Git</span>
            </v-tooltip>

            <span class="text-body-1 ml-4">
              <u> {{ refno }}</u> numaralı siparişi

              <v-chip class="ml-2" color="warning" outlined>
                <v-icon left small>{{ icons.mdiPencil }}</v-icon>
                Düzenliyorsunuz</v-chip
              >
            </span>
          </v-card-title>
          <v-divider v-if="isEdit" />
          <v-stepper v-model="callCenterStep" vertical rounded="xl" class="pa-3">
            <v-stepper-step :complete="callCenterStep > 1" step="1" :editable="callCenterStep > 1">
              <StepperTitle
                :step="1"
                :icon="icons.mdiAccount"
                title="Müşteri Bilgileri"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="1">
              <StepperContentCustomer />
            </v-stepper-content>

            <v-stepper-step step="2" :complete="callCenterStep > 2" :editable="callCenterStep > 2">
              <StepperTitle
                :step="2"
                :icon="icons.mdiMoped"
                title="Teslimat Bilgileri"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="2">
              <StepperContentDelivery v-if="isDelivery" />
            </v-stepper-content>

            <v-stepper-step step="3" :complete="callCenterStep > 3" :editable="callCenterStep > 3">
              <StepperTitle
                :step="3"
                :icon="icons.mdiOrderBoolDescending"
                title="Sipariş Bilgileri"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="3">
              <StepperContentOrder v-if="isOrder" />
            </v-stepper-content>

            <v-stepper-step
              v-show="isInvoiceShow"
              step="4"
              :complete="callCenterStep > 4"
              :editable="callCenterStep > 4"
            >
              <StepperTitle
                :step="4"
                :icon="icons.mdiReceiptText"
                title="Fatura Bilgileri"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="4" v-if="isInvoiceShow">
              <StepperContentInvoice />
            </v-stepper-content>

            <v-stepper-step step="5">
              <StepperTitle
                :icon="icons.mdiTextLong"
                title="Özet"
                subtitle="İstenilen bilgileri doldurun"
              />
            </v-stepper-step>

            <v-stepper-content step="5">
              <StepperContentSummary />
            </v-stepper-content>
          </v-stepper>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { useCallCenterStore } from "@/stores/callCenter";
import { storeToRefs } from "pinia";
// Icon
import {
  mdiAccount,
  mdiOrderBoolDescending,
  mdiMoped,
  mdiReceiptText,
  mdiTextLong,
  mdiArrowLeft,
  mdiPencil,
} from "@mdi/js";
import { useRouter } from "@core/utils";
import StepperTitle from "./StepperTitle.vue";
import StepperContentCustomer from "./steps/customer/Index.vue";
import StepperContentOrder from "./steps/order/Index.vue";
import StepperContentDelivery from "./steps/delivery/Index.vue";
import StepperContentInvoice from "./steps/invoice/Index.vue";
import StepperContentSummary from "./steps/summary/Index.vue";
export default {
  components: {
    StepperTitle,
    StepperContentCustomer,
    StepperContentOrder,
    StepperContentDelivery,
    StepperContentInvoice,
    StepperContentSummary,
  },
  setup() {
    const callCenterStore = useCallCenterStore();

    const { route, router } = useRouter();

    const { callCenterStep, isOrderShow, isDeliveryShow, isInvoiceShow, isSummaryShow } =
      storeToRefs(callCenterStore);

    const isOrder = computed(() => {
      // Order component bir sefer gösterildi ise
      if (isOrderShow.value) return true;

      // Step durumuna göre gösterime bakıyoruz
      return callCenterStep.value > 2 ? (true, (isOrderShow.value = true)) : false;
    });

    const isDelivery = computed(() => {
      // Order component bir sefer gösterildi ise
      if (isDeliveryShow.value) return true;

      // Step durumuna göre gösterime bakıyoruz
      return callCenterStep.value > 1 ? (true, (isDeliveryShow.value = true)) : false;
    });

    const isSummary = computed(() => {
      // Order component bir sefer gösterildi ise
      if (isSummaryShow.value) return true;

      // Step durumuna göre gösterime bakıyoruz
      return callCenterStep.value > 4 ? (true, (isSummaryShow.value = true)) : false;
    });

    const editData = (item) => {
      // Customer
      callCenterStore.data.customer.name = item.name;
      callCenterStore.data.customer.surname = item.surname;
      callCenterStore.data.customer.tel = item.tel;
      callCenterStore.data.customer.email = item.email;

      // Order
      callCenterStore.data.baskets = item.lines.map((el) => {
        return {
          uid: el.uid,
          qty: el.qty,
        };
      });

      // Delivery
      callCenterStore.data.delivery.deliverydate = item.deliverydate;
      callCenterStore.data.delivery.deliveryhour = item.deliveryhour;
      callCenterStore.data.delivery.paymenttype = item.paymenttype;
      callCenterStore.data.delivery.customer = item.customer;
      callCenterStore.data.delivery.officename = item.officename;
      callCenterStore.data.delivery.city = item.city;
      callCenterStore.data.delivery.state = item.state;
      callCenterStore.data.delivery.address = item.address;
      callCenterStore.data.delivery.notes = item.notes;
      callCenterStore.data.delivery.needinvoice = item.needinvoice;
      callCenterStore.data.delivery.isdifferentinvoiceaddr = item.isdifferentinvoiceaddr;

      if (callCenterStore.data.delivery.isdifferentinvoiceaddr) {
        callCenterStore.isInvoiceShow = true;
      }
    };

    // Düzenleme yaparken fatura durumu inceleniyor
    watch(
      () => callCenterStore.isInvoiceShow,
      (val) => {
        const item = route.value?.params?.item;
        if (val && item) {
          callCenterStore.data.invoice.invaddrname = item.invaddrname;
          callCenterStore.data.invoice.invaddrsurname = item.invaddrsurname;
          callCenterStore.data.invoice.invaddrcompname = item.invaddrcompname;
          callCenterStore.data.invoice.invaddrvatno = item.invaddrvatno;
          callCenterStore.data.invoice.invaddrtaxtdept = item.invaddrtaxtdept;
          callCenterStore.data.invoice.invaddreinvtype = item.invaddreinvtype;
          callCenterStore.data.invoice.invaddrtel = item.invaddrtel;
          callCenterStore.data.invoice.invaddremail = item.invaddremail;
          callCenterStore.data.invoice.invaddrcity = item.invaddrcity;
          callCenterStore.data.invoice.invaddrstate = item.invaddrstate;
          callCenterStore.data.invoice.invaddr = item.invaddr;
        }
      }
    );

    const refno = ref("");
    const isEdit = ref(false);

    onMounted(() => {
      callCenterStore.isChangePage = false;

      if (route.value.params.item) {
        refno.value = route.value.params.item.refno;
        isEdit.value = true;
        editData(route.value.params.item);
      }
    });

    return {
      callCenterStore,
      callCenterStep,
      isOrder,
      isDelivery,
      isInvoiceShow,
      isSummary,
      isEdit,
      refno,

      icons: {
        mdiAccount,
        mdiOrderBoolDescending,
        mdiMoped,
        mdiReceiptText,
        mdiTextLong,
        mdiArrowLeft,
        mdiPencil,
      },
    };
  },
};
</script>
